"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";

const AccountBar = ({ sideData }) => {
  const pathname = usePathname();
  const cleanedPathname = pathname.replace(/^\/(az|en|ru)/, "");

  return (
    <>
      {sideData?.map((sub, index) =>
        index === sideData.length - 1 ? (
          <div className="accountNav" key={index}>
            {sub.sub_menus.map((item) => {
              const linkPath = `/${item.path}`;
              const isActive = cleanedPathname === linkPath;
              return (
                <Link
                  key={item.id}
                  href={`/${item.path}`}
                  className={isActive ? "active" : ""}
                >
                  {item.title}
                </Link>
              );
            })}
          </div>
        ) : null
      )}
    </>
  );
};

export default AccountBar;
